
// Class implementation for DataHubRepository
export class DataHubRepository {
    Name: string;
    RepositoryLink: string;
    Description: string;
    IsAutomaticallyRegistered: number;
    DataTypes: string[];
    OrganismRestrictions: string;
    SupportsEmbargo: string;
    AccessControlCapability: string;
    CurationServices: string;
    Cost: string;
    GuidanceLink: string;


    public getDetailsHtml(): string {
        let automaticallyRegisteredDisplay = "Yes";
        if (this.IsAutomaticallyRegistered == 0) {
            automaticallyRegisteredDisplay = "No";
        }
        else if (this.IsAutomaticallyRegistered == 2) {
            automaticallyRegisteredDisplay = "Sometimes";
        }

        return `
            <div class="details-container">
                <!-- First Row: Repository Name and Links -->
                <div class="row">
                    <div class="col-md-6 col-xs-12" style="text-align: left;">
                        <div class="detail-item">
                            <span style="font-weight: 700; font-size: 16px;">${this.Name}</span>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12" style="text-align: right;">
                        <span class="inline-item" style="margin-right: 0;">
                            <a href="${this.GuidanceLink}" target="_blank">Guidance Link</a>
                            <i class="fa-solid fa-up-right-from-square" style="margin-right: 10px;"></i>
                        </span>
                        <span class="separator">|</span>
                        <span class="inline-item">
                            <a href="${this.RepositoryLink}" target="_blank" style="text-align: left;">Visit Repository</a>
                            <i class="fa-solid fa-up-right-from-square" style="margin-right: 10px;"></i>
                        </span>
                    </div>
                </div>
             

                <!-- Description Row (Full Width) -->
                <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <div class="detail-item">
                            <span class="inner-title font-size12">Description</span>
                            <span class="inner-body">${this.Description}</span>
                        </div>
                    </div>
                </div>
              

                <!-- Auto-Sizing Rows -->
                <div class="row">
                    <div class="col-auto">
                        <div class="detail-item">
                            <span class="inner-title font-size12">Asset Types</span>
                            <span>
                                ${this.DataTypes.length > 0
                            ? this.DataTypes.map(type => `<span class="inline-list-item">${type}</span>`).join(' ')
                            : 'Not specified'}
                            </span>
                        </div>
                    </div>
                </div>
                <hr class="grey-inner-line">

                <!-- Additional Details -->
                <div class="row justify-content-between">
                    <div class="col-auto center-pills">
                        <div class="detail-item">
                            <span class="inner-title font-size12">Automatically Registered</span>
                            <span class="inline-list-item inner-body blue-pill">${automaticallyRegisteredDisplay}</span>
                        </div>
                    </div>
                    <div class="col-auto center-pills">
                        <div class="detail-item">
                            <span class="inner-title font-size12">Restrictions</span>
                            <span class="inline-list-item inner-body blue-pill">${this.OrganismRestrictions || 'Not specified'}</span>
                        </div>
                    </div>
                    <div class="col-auto center-pills">
                        <div class="detail-item">
                            <span class="inner-title font-size12">Supports Embargo</span>
                            <span class="inline-list-item inner-body blue-pill">${this.SupportsEmbargo || 'Not specified'}</span>
                        </div>
                    </div>
                    <div class="col-auto center-pills">
                        <div class="detail-item">
                            <span class="inner-title font-size12">Access Control Capability</span>
                            <span class="inline-list-item inner-body blue-pill">${this.AccessControlCapability || 'Not specified'}</span>
                        </div>
                    </div>
                    <div class="col-auto center-pills">
                        <div class="detail-item">
                            <span class="inner-title">Curation Services</span>
                            <span class="inline-list-item inner-body blue-pill">${this.CurationServices || 'Not specified'}</span>
                        </div>
                    </div>
                    <div class="col-auto center-pills">
                        <div class="detail-item">
                            <span class="inner-title">Cost</span>
                            <span class="inline-list-item inner-body blue-pill">${this.Cost || 'Not specified'}</span>
                        </div>
                    </div>
                </div>
            </div>`;
    }
}

export class MetadataField {
    FieldName: string;
    IsRequired: boolean;
    Description: string;
}
